export default __webpack_public_path__ + "static/media/seat-lounger.3826d1b6.svg";